export var FeatureName;
(function (FeatureName) {
    FeatureName["Passthrough"] = "passthrough";
})(FeatureName || (FeatureName = {}));
export class FeatureManager {
    constructor() {
        this._features = {};
        this._featureTests = new Map();
        this._featureSupported = new Map();
        this._featureStates = new Map();
    }
    static get instance() {
        if (this._instance === null)
            this._instance = new FeatureManager();
        return this._instance;
    }
    setFeatures(features) {
        if (features === undefined)
            return;
        for (const featureName in features) {
            const feature = featureName;
            this._features[feature] = features[feature];
            this._featureStates.set(feature, false);
        }
    }
    setTest(feature, test) {
        this._featureTests.set(feature, test);
    }
    isFeatureRequested(feature) {
        if (this._features[feature] === undefined)
            return false;
        if (this._features[feature] === "disabled")
            return false;
        if (this._features[feature] === "required")
            return true;
        if (!this._featureTests.has(feature))
            return true;
        return this._featureTests.get(feature)();
    }
    isFeatureSupported(feature) {
        return this._featureSupported.get(feature) ?? false;
    }
    setFeatureSupported(feature, isSupported) {
        this._featureSupported.set(feature, isSupported);
    }
    isFeatureEnabled(feature) {
        return this._featureStates.get(feature) ?? false;
    }
    setFeatureEnabled(feature, isOn) {
        if (!this._featureStates.has(feature))
            return;
        this._featureStates.set(feature, isOn);
    }
}
FeatureManager._instance = null;
